/* unplugin-vue-components disabled */import { render } from "./panel.vue?vue&type=template&id=8ce367f8&scoped=true"
import script from "./panel.vue?vue&type=script&setup=true&lang=js"
export * from "./panel.vue?vue&type=script&setup=true&lang=js"

import "./panel.vue?vue&type=style&index=0&id=8ce367f8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ce367f8"],['__file',"src/controls/panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8ce367f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8ce367f8', __exports__)) {
    api.reload('8ce367f8', __exports__)
  }
  
  module.hot.accept("./panel.vue?vue&type=template&id=8ce367f8&scoped=true", () => {
    api.rerender('8ce367f8', render)
  })

}


export default __exports__